import { useCallback } from 'react'
import { formatDistance, type FormatDistanceParams } from '@terros/common'
import { usePreference } from './get'

type ResultFn = (miles: number, options?: Pick<FormatDistanceParams, 'unitDisplay'>) => string
export const useDisplayDistance = (): ResultFn => {
  const { data: unitSystem } = usePreference('unitSystem')
  return useCallback(
    (miles: number, options?: Pick<FormatDistanceParams, 'unitDisplay'>): string => {
      return formatDistance({ miles, unitSystem, ...options })
    },
    [unitSystem]
  )
}
